import { BROWSER, DEV } from "@workwave-tidal/env";
import { DEV as DEV2, BROWSER as BROWSER2 } from "@workwave-tidal/env";
function isDev() {
  try {
    return DEV && BROWSER;
  } catch (e) {
    return false;
  }
}
export {
  BROWSER2 as BROWSER,
  DEV2 as DEV,
  isDev
};
//# sourceMappingURL=isDev.js.map
